import { validationMethods } from '../../../Utils/validationMethods';

const validation = {
  fname: validationMethods.requiredString,
  lname: validationMethods.requiredString,
  email: validationMethods.requiredEmail,
  phone: validationMethods.optionalString,
  branchId: validationMethods.requiredString,
  description: validationMethods.optionalString,
};

export default validation;
